var render = function () {
  var _vm$paymentReports, _vm$filteredData;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "income"
  }, [_c('div', {
    staticClass: "flex mdmax:flex-col mdmax:items-start items-end gap-5 mdmax:gap-4 mb-6"
  }, [_c('div', {
    staticClass: "w-1/2 mdmax:w-full flex items-center gap-5"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('report.month')))]), _c('CustomSelect', {
    attrs: {
      "options": _vm.monthList,
      "default": _vm.selectedMonth
    },
    on: {
      "change": function change($event) {
        return _vm.triggerDateChange();
      }
    },
    model: {
      value: _vm.selectedMonth,
      callback: function callback($$v) {
        _vm.selectedMonth = $$v;
      },
      expression: "selectedMonth"
    }
  })], 1), _c('div', {
    staticClass: "w-1/2"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v(_vm._s(_vm.$t('report.year')))]), _c('CustomSelect', {
    attrs: {
      "options": _vm.yearList,
      "default": _vm.selectedYear
    },
    on: {
      "change": function change($event) {
        return _vm.triggerDateChange();
      }
    },
    model: {
      value: _vm.selectedYear,
      callback: function callback($$v) {
        _vm.selectedYear = $$v;
      },
      expression: "selectedYear"
    }
  })], 1)]), _c('div', {
    staticClass: "w-1/2 mdmax:w-full flex mdmax:flex-col mdmax:items-start justify-between items-end gap-5 mdmax:gap-4"
  }, [_c('div', {
    staticClass: "w-1/2 mdmax:w-full pb-3 mdmax:pb-0 text-sm"
  }, [_vm._v(" " + _vm._s(_vm.$t('report.totalPayout')) + ": "), _c('span', {
    staticClass: "inline-block font-bold text-xl"
  }, [_vm._v(_vm._s(_vm._f("currencyFormat")((_vm$paymentReports = _vm.paymentReports) === null || _vm$paymentReports === void 0 ? void 0 : _vm$paymentReports.total)))])]), _c('div', {
    staticClass: "w-1/2 mdmax:w-full flex justify-end mdmax:justify-start"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Export Data",
      "size": "big",
      "icon": function icon() {
        return import('@/components/Icons/Export');
      }
    },
    on: {
      "action": function action($event) {
        return _vm.downloadReports();
      }
    }
  })], 1)])]), _c('div', {}, [_c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData,
      "compact": ""
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'date' ? _c('div', [_vm._v(_vm._s(_vm._f("formatDate")(entry.date)))]) : column.field === 'transaction' ? _c('div', [_c('p', {
          staticClass: "mb-1"
        }, [_vm._v(_vm._s(entry.package_origin) + " - " + _vm._s(entry.package_destination))]), _c('p', {
          staticClass: "text-xs text-neutral-500"
        }, [_vm._v("AWB: " + _vm._s(entry.package_shipment_awb))])]) : column.field === 'payment_amount' ? _c('div', [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(entry.payment_amount)) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field] || '-'))])];
      }
    }])
  }), ((_vm$filteredData = _vm.filteredData) === null || _vm$filteredData === void 0 ? void 0 : _vm$filteredData.length) > 0 ? [!_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(_vm._s(_vm.$t('report.show')) + " " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " " + _vm._s(_vm.$t('report.from')) + " " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-end mdmax:justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()] : _vm._e()], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }